import React, { type FC, useState } from "react";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Styles from "./styles/SpecList";
import * as SummaryStyles from "./styles/SummaryEcoConsumption";
import * as IconWrapper from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { EcoConsumptionSectionType } from "../../../../../shared-modules/eco-consumption-section/types/EcoConsumptionType";
import { IntegratedEcoConsumptionSection } from "../../../../../shared-modules/eco-consumption-section/components/IntegratedEcoConsumptionSection";
import { trackExpandSpecCategory } from "../../../utils/tracking";
import Popover from "../../../../../../common-deprecated/components/popover/aem/lexus/Popover";

export const SummaryEcoConsumption: FC<{
    ecoConsumptionConfiguration: EcoConsumptionSectionType;
}> = (props) => {
    const { ecoConsumptionConfiguration } = props;

    const [isOpen, setIsOpen] = useState(true);
    const toggleState = (): void => {
        if (!isOpen) {
            trackExpandSpecCategory("eco");
        }
        setIsOpen(!isOpen);
    };

    return (
        <Styles.Wrapper isOpen={isOpen}>
            <Styles.Header
                as="a"
                onClick={toggleState}
                id="summary-eco-consumption-header"
                aria-expanded={isOpen}
                aria-controls="summary-eco-consumption"
            >
                <Styles.DropDownTitle>{ecoConsumptionConfiguration.title}</Styles.DropDownTitle>
                <IconWrapper.ToggleIconWrapper isDown={isOpen} aria-hidden="true">
                    <Icon variant="chevronDown" />
                </IconWrapper.ToggleIconWrapper>
            </Styles.Header>
            {isOpen && (
                <Styles.DropDown id="summary-eco-consumption" aria-labelledby="summary-eco-consumption-header">
                    <SummaryStyles.EcoConsumptionWrapper>
                        <IntegratedEcoConsumptionSection
                            ecoConsumptionConfiguration={ecoConsumptionConfiguration}
                            PopoverTooltip={(tooltip: { content: string }) => (
                                <Popover showOnClick useHTML content={tooltip.content} />
                            )}
                        />
                    </SummaryStyles.EcoConsumptionWrapper>
                </Styles.DropDown>
            )}
        </Styles.Wrapper>
    );
};
